exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-Loading[data-v-36fa04e0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:fixed!important;top:0;left:0;width:100vw;height:100vh;z-index:9999!important;background-color:#fff}.circle-Loading .loading-wait[data-v-36fa04e0]{font-size:2rem;font-family:Muli,Lato;line-height:1.2;font-weight:400;color:#434343;margin:2rem 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36fa04e0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/login-v5/spinners/CircleSpinner.vue
// module id = vF/i
// module chunks = 0